export const stripHTML = (tableName?: string) =>
  new DOMParser().parseFromString(tableName ?? '', 'text/html').body.textContent;
